var map = {
	"./en": "./node_modules/scratch-vm/src/extensions/scratch3_poppy/lang/en.js",
	"./en.js": "./node_modules/scratch-vm/src/extensions/scratch3_poppy/lang/en.js",
	"./fr": "./node_modules/scratch-vm/src/extensions/scratch3_poppy/lang/fr.js",
	"./fr.js": "./node_modules/scratch-vm/src/extensions/scratch3_poppy/lang/fr.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./node_modules/scratch-vm/src/extensions/scratch3_poppy/lang sync recursive ^\\.\\/.*$";